import React, { useState } from 'react';
import Dollar from "../../../Assests/Dollar Coins.svg";
import messageIcon from "../../../Assests/cardMsg.svg";
import Avatar from "../../../Assests/avatar.svg";
import { useSelector } from 'react-redux';
import ConnectButton from '../../../Components/ConnectButton';
import StaredUser from './StaredUser';
import ActionButtonIcon from "../../../Assests/Action Button.svg";
import KebabIcon from "../../../Assests/kebab menu.svg";
import BlockIcon from "../../../Assests/block.png";
import ReportIcon from "../../../Assests/Report.svg";
import ActionConfirmDialog from '../../../Components/ActionConfirmDialog';
import UndoToast from '../../../Components/UndoToast';
import ReportProfileDialog from '../../../Components/ReportProfileDialog';
import { useActionDialogs } from './useActionDialogs';
import UnfollowIcon from '../../../Assests/Unfollow.svg';
import PropTypes from 'prop-types';
import TickIcon from '../../../Assests/Tick.svg';
import CloseIcon from '../../../CometChat/assets/close.svg';
import '../../../Pages/ConnectionPages/Connection.css';
import { capitalizeNames } from '../../../utils/nameUtils';

// Extracted ActionMenu component for reuse

export function ActionMenu({
  isOpen,
  anchorRef,
  onClose,
  onUnfollow,
  onBlock,
  onReport,
  hovered,
  setHovered,
  menuRef,
  customStyle
}) {
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target) && anchorRef.current && !anchorRef.current.contains(event.target)) {
        onClose();
      }
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose, menuRef, anchorRef]);

  if (!isOpen) return null;
  
  const defaultStyle = {
    position: 'absolute',
    left: "-5vh", 
    width: "13vh",
    minWidth: "13vh",
    maxWidth: "13vh",
    height: "16.8vh",
    background: 'rgba(255, 255, 255, 0.08)',
    borderRadius: "1.6vh",
    border: '0.15vh solid rgba(255, 255, 255, 0.25)',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    color: '#fff',
    padding: '0.4vh',
    boxSizing: 'border-box',
    backdropFilter: 'blur(1.6vh)',
    WebkitBackdropFilter: 'blur(1.6vh)',
    top: '4.8vh',
    bottom: 'auto',
  };

  const getButtonStyle = (actionType) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: "0.8vh",
    padding: '0.5vh 0.8vh',
    cursor: 'pointer',
    borderRadius: "0.8vh",
    background: hovered === actionType ? 'rgba(38, 88, 215, 1)' : 'transparent',
    border: hovered === actionType ? '0.1vh solid #fff' : '0.1vh solid transparent',
    color: '#fff',
    fontWeight: 500,
    fontSize: "1.3vh",
    transition: 'background 0.2s, border-color 0.2s',
    width: '100%',
    textAlign: 'left',
  });

  const getIconStyle = () => ({
    width: "2.2vh",
    height: "2.2vh",
    filter: 'brightness(0) invert(1)'
  });

  const actionItems = [
    {
      type: 'unfollow',
      icon: UnfollowIcon,
      label: 'Unfollow',
      onClick: onUnfollow,
      alt: 'Unfollow'
    },
    {
      type: 'block',
      icon: BlockIcon,
      label: 'Block',
      onClick: onBlock,
      alt: 'Block'
    },
    {
      type: 'report',
      icon: ReportIcon,
      label: 'Report',
      onClick: onReport,
      alt: 'Report'
    }
  ];

  return (
    <div ref={menuRef} className="action-popup" style={customStyle ? { ...defaultStyle, ...customStyle } : defaultStyle}>
      {actionItems.map(({ type, icon: Icon, label, onClick, alt }) => (
        <button
          key={type}
          type="button"
          className="action-popup-row"
          style={getButtonStyle(type)}
          onMouseEnter={() => setHovered(type)}
          onMouseLeave={() => setHovered('')}
          onClick={onClick}
        >
          <img src={Icon} alt={alt} style={getIconStyle()} /> {label}
        </button>
      ))}
    </div>
  );
}

ActionMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  anchorRef: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onUnfollow: PropTypes.func.isRequired,
  onBlock: PropTypes.func.isRequired,
  onReport: PropTypes.func.isRequired,
  hovered: PropTypes.string.isRequired,
  setHovered: PropTypes.func.isRequired,
  menuRef: PropTypes.object.isRequired,
  customStyle: PropTypes.object,
};

const CommunityProfileCard = ({
    userConnection,
    creater,
    handleClickViewProfile,
    handleConnectionClick,
    showInterests = true,
    type,
    onAccept,
    onDecline,
    fetchConnections,
    onActionPopupToggle
}) => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = React.useRef(null);
    const [hovered, setHovered] = useState('');
    const value = useSelector((state) => state?.value)
    let filterValue = value ? value?.filterValue : "";
    const {
      dialogConfig,
      setDialogConfig,
      isReportDialogOpen,
      setIsReportDialogOpen,
      toastConfig,
      setToastConfig,
      handleUnfollow,
      handleBlock,
      handleReport,
      onReport,
      handleUndo,
    } = useActionDialogs(capitalizeNames(creater?.FirstName, creater?.LastName).fullName, creater?.UserID, fetchConnections);

    const {
        UserID,
        FirstName, LastName,
        Collaborate,
        ProfileImageKey,
        Bio,
        Rate,
        ConnectionStatus,
        IsStarred,
        Topics } = creater;

    const isOpenToCollaborate = Boolean(Collaborate)

    const userName = capitalizeNames(FirstName, LastName).fullName;

    let topicsArray = [];
    topicsArray = Topics ? JSON.parse(Topics) : ["No interests available"];

    const handleMenuClick = (e) => {
        e.stopPropagation();
        setIsMenuOpen((prev) => {
            const newState = !prev;
            if (onActionPopupToggle) {
                onActionPopupToggle(newState);
            }
            return newState;
        });
    };

    React.useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
                if (onActionPopupToggle) {
                    onActionPopupToggle(false);
                }
            }
        }
        if (isMenuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isMenuOpen]);

    return (
        <div className='profilecard_container' style={{ position: 'relative', width: '100%', minWidth: 0, maxWidth: '100%' }}>
            {type === 'request' && (
                <button 
                    className="view-profile-btn-top" 
                    onClick={() => handleClickViewProfile(creater)}
                    style={{ 
                        position: 'absolute', 
                        top: '1.6vh', 
                        right: '1.6vh', 
                        width: '12.7vh',
                        height: '4vh',
                        borderRadius: '1.6vh',
                        padding: '0.8vh 1.6vh',
                        background: 'transparent', 
                        color: '#fff', 
                        border: '0.1vh solid #fff', 
                        fontSize: '1.6vh', 
                        fontWeight: 500, 
                        zIndex: 2, 
                        cursor: 'pointer',
                        boxShadow: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.8vh'
                    }}
                >
                    View Profile
                </button>
            )}
            <div className='profilecard_container_top'>
                <div className='profilecard_header'>
                    <div className='profilecard_user_img'>
                        <img src={ProfileImageKey || Avatar} alt="Profile" />
                    </div>
                    <div className='profilecard_user_info'>
                        <div className='profilecard_user_info_title'>
                            <div className='profilecard_user_name ellipsis'>
                                <span>{capitalizeNames(FirstName, LastName).fullName}</span>

                            </div>
                            <div className='d-flex align-items-center' style={{ gap: "1vh", position: 'relative' }}>
                                {userConnection && type !== 'request' && <StaredUser startActive={IsStarred} userId={UserID} />}
                                {userConnection && type !== 'request' &&
                                    <button onClick={handleMenuClick} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                                        <img src={isMenuOpen ? KebabIcon : ActionButtonIcon} alt='actions' />
                                    </button>
                                }
                                {isMenuOpen && (
                                    <ActionMenu
                                        isOpen={isMenuOpen}
                                        anchorRef={menuRef}
                                        onClose={() => setIsMenuOpen(false)}
                                        onUnfollow={handleUnfollow}
                                        onBlock={handleBlock}
                                        onReport={handleReport}
                                        hovered={hovered}
                                        setHovered={setHovered}
                                        menuRef={menuRef}
                                    />
                                )}
                            </div>
                        </div>
                        {/* <span className="profilecard_user_role">Podcast Creator</span> */}
                    </div>
                </div>
                <div className='profilecard_user_status'>
                    <div className='profilecard_collab_status'>
                        <div className={isOpenToCollaborate ?
                            'profilecard_collab_open_status' : 'profilecard_collab_close_status'
                        }>
                        </div>
                        <span>
                            {isOpenToCollaborate ? "Open to Collaboration" : "Closed to Collaboration"}
                        </span>
                    </div>
                    <div className='profilecard_rate_status'>
                        <img src={Dollar} alt="Rate" />
                        <div>
                            <span style={{fontSize: "1.6vh"}}>$</span>
                            <span>{Rate ? Rate : '-'}</span>
                            <span>/Ep</span>
                        </div>
                    </div>
                </div>
            </div>
            {type === 'request' && (
                <div className='profilecard_container_mid_bio' style={{ marginBottom: '0px' }}>
                    <div className='profilecard_mid_bio_text' style={{ color: '#fff', fontSize: '1.4vh', lineHeight: '1.5', marginBottom: '0.8vh' }}>
                        {Bio || "Explore the intersection of technology and creativity. Join me in discussing the latest trends and innovation..."}
                    </div>
                </div>
            )}
            {showInterests && (
                <div className='profilecard_container_mid_topic'>
                    <span className='profilecard_container_mid_title'>
                        Interests
                    </span>
                    <div className='profilecard_mid_topics'>
                        {
                            [...topicsArray]
                                .sort((a, b) => {
                                    const aMatch = a?.toLowerCase().includes(filterValue?.toLowerCase());
                                    const bMatch = b?.toLowerCase().includes(filterValue?.toLowerCase());
                                    return (bMatch === aMatch) ? 0 : bMatch ? 1 : -1; // Put matches at the top
                                })
                                .map((item, index) => {
                                    const isMatch = item?.toLowerCase().includes(filterValue?.toLowerCase());
                                    return (
                                        <div
                                            key={index}
                                            className={`profilecard_mid_topics_item ${isMatch && !userConnection ? "searched_topic" : ""}`}
                                        >
                                            <span>#</span>
                                            <span>{item}</span>
                                        </div>
                                    );
                                })
                        }
                    </div>
                </div>
            )}
            
            <div className='profilecard_container_bottom'>
                {type === 'request' ? (
                  <div className="pending_connection_profile_button" style={{ display: 'flex', justifyContent: 'flex-end', gap: '1.6vh' }}>
                    <button 
                      type="button"
                      className="profile_connection_button pointer decline" 
                      onClick={onDecline} 
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          onDecline();
                        }
                      }}
                      style={{ width: '17.6vh', height: '4vh', borderRadius: '1.6vh', padding: '0.8vh 1.6vh', gap: '0.8vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: '#fff', fontWeight: 500, fontSize: "1.6vh", cursor: 'pointer', transition: 'background 0.2s' }} 
                      onMouseEnter={(e) => e.target.style.background = 'rgba(41, 104, 254, 0.1)'} 
                      onMouseLeave={(e) => e.target.style.background = 'transparent'}
                    >
                      <span>Decline</span>
                      <img src={CloseIcon} alt="Decline" style={{ width: '2vh', height: '2vh', filter: 'brightness(0) invert(1)' }} />
                    </button>
                    <button 
                      type="button"
                      className="profile_connection_button pointer accept" 
                      onClick={onAccept} 
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          onAccept();
                        }
                      }}
                      style={{ width: '17.6vh', height: '4vh', borderRadius: '1.6vh', padding: '0.8vh 1.6vh', gap: '0.8vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#2968FE', border: 'none', color: '#fff', fontWeight: 500, fontSize: "1.6vh" }}
                    >
                      <span>Accept</span>
                      <img src={TickIcon} alt="Accept" style={{ width: '2vh', height: '2vh' }} />
                    </button>
                  </div>
                ) : (
                  <>
                    <button className="profilecard_container_profile_bottom"
                        onClick={() => handleClickViewProfile(creater)}>
                        <span>View Profile</span>
                    </button>
                    {
                        userConnection ?
                            <button className="profilecard_container_message_bottom"
                                onClick={() => handleConnectionClick(UserID)}
                            >
                                <span>Message</span>
                                <img src={messageIcon} alt="Message" />
                            </button> :
                            <div className="profilecard_container_connection_bottom">
                                <ConnectButton fullWidth={true} ConnectionStatus={ConnectionStatus} ReceiverID={UserID} />
                            </div>
                    }
                  </>
                )}
            </div>
            {dialogConfig && (
                <ActionConfirmDialog
                    open={Boolean(dialogConfig)}
                    onClose={() => setDialogConfig(null)}
                    title={dialogConfig.title}
                    message1={dialogConfig.message1}
                    message2={dialogConfig.message2}
                    actionText={dialogConfig.actionText}
                    onAction={dialogConfig.onAction}
                    actionIcon={dialogConfig.actionIcon}
                />
            )}
            <ReportProfileDialog
                open={isReportDialogOpen}
                onClose={() => setIsReportDialogOpen(false)}
                userName={userName}
                onReport={onReport}
            />
            <UndoToast
                message={toastConfig.message}
                visible={toastConfig.visible}
                showUndo={toastConfig.showUndo}
                onUndo={handleUndo}
            />
        </div>
    )
}

CommunityProfileCard.propTypes = {
  userConnection: PropTypes.bool,
  creater: PropTypes.shape({
    UserID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    FirstName: PropTypes.string,
    LastName: PropTypes.string,
    Collaborate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    ProfileImageKey: PropTypes.string,
    Bio: PropTypes.string,
    Rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ConnectionStatus: PropTypes.string,
    IsStarred: PropTypes.bool,
    Topics: PropTypes.string,
  }).isRequired,
  handleClickViewProfile: PropTypes.func.isRequired,
  handleConnectionClick: PropTypes.func.isRequired,
  showInterests: PropTypes.bool,
  type: PropTypes.string,
  onAccept: PropTypes.func,
  onDecline: PropTypes.func,
  fetchConnections: PropTypes.func, // Optional - only needed for connection management
  onActionPopupToggle: PropTypes.func, // Optional - callback when action popup opens/closes
};

export default CommunityProfileCard;